import { createSlice } from '@reduxjs/toolkit';

export interface UserData {
    userName: string;
    phoneNumber: string;
    email: string;
    userType: string;
    isLoading: boolean;
    isMobile: boolean;
    isFetched: string;
}

// Define initial state
const initialState: { userData: UserData } = {
    userData: {
        userName: '',
        phoneNumber: '',
        email: '',
        userType: '',
        isLoading: false,
        isMobile: false,
        isFetched: '',
    },
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserData(state, action) {
            state.userData = { ...state.userData, ...action.payload };
        },
        setUserType(state, action) {
            state.userData.userType = action.payload;
        },
        setUserDataLoading(state, action) {
            state.userData.isLoading = action.payload;
            if (action.payload === false) {
                state.userData.isFetched = 'yes';
            }
        },
        setIsMobile: (state, action) => {
            state.userData.isMobile = action.payload;
        },
    },
});

// Selectors
export const getUserDetails = (state: any) => state.userData?.userData;
export const getUserDetailsFetchStatus = (state: any) =>
    state.userData?.userData?.isFetched;

export const selectIsMobile = (state: any) => state.userData?.userData.isMobile;

//Set user data
export const { setUserData, setUserType, setUserDataLoading, setIsMobile } =
    userSlice.actions;

export default userSlice.reducer;
